/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Error_Agent_Step_LimitInputs */



/**
* | output |
* | --- |
* | "The agent reached its action limit for this run. Raise the limit in the agent settings if it needs more steps." |
*
* @param {Chat_Error_Agent_Step_LimitInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_error_agent_step_limit = /** @type {((inputs?: Chat_Error_Agent_Step_LimitInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Error_Agent_Step_LimitInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Agent hat sein Aktionslimit für diesen Lauf erreicht. Erhöhen Sie das Limit in den Einstellungen des Agenten, wenn er mehr Schritte braucht.")
	return /** @type {LocalizedString} */ ("The agent reached its action limit for this run. Raise the limit in the agent settings if it needs more steps.")
});